import React from 'react'

const ContactMap = () => {
    return (
        <section className='section-map'>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-12'>
                        <iframe
                            title="India Embroidery Location Map"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3773.5789894976597!2d72.8320918!3d18.9500205!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7ce23c084af5b%3A0xc8a423e469a995ff!2sIndia%20Embroidery!5e0!3m2!1sen!2sro!4v1749811090438!5m2!1sen!2sro"
                            width="100%"
                            height="450"
                            style={{ border: 0 }}
                            allowFullScreen
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />

                    </div>
                </div>
            </div>
        </section>
    )
}

export default ContactMap